import * as _ from "lodash";

import { EvalFunction, parse, SymbolNode, MathNode, FunctionNode, ConstantNode } from "mathjs"

// To avoid the cost of parsing and compiling an expression
// use a dictionary to index the expression and compile and parse it only once

export interface IExpressionCacheEntry {
    expression: string

    error: boolean
    errorMessage?: string

    // On Success, there are available
    expressionNode?: MathNode
    symbols?: string[]
    functions?: string[]
    expressionFnc?: EvalFunction
}

export class ExpressionCache {

    private dct: {[expression: string]: IExpressionCacheEntry};

    constructor() {
        this.dct = {}
    }

    get(expression: string): IExpressionCacheEntry {
        if(_.isEmpty(expression) || !_.isString(expression))
            return undefined;

        if(expression in this.dct)
            return this.dct[expression];

        const dctSymbols: {[symbolId: string]: string} = {}
        const dctFunction: {[funcId: string]: string} = {}


        // parse, compile
        let rv: IExpressionCacheEntry = {
            expression: expression,
            error: false
        }

        try {
            rv.expressionNode = parse(expression);
            rv.expressionNode.traverse((node: (MathNode | SymbolNode | FunctionNode) & any  , path, parent) => {
                if (node.type == "SymbolNode") {
                    dctSymbols[node?.name] = node?.name;
                } else if (node.type == "FunctionNode") {
                    dctFunction[node.name] = node.name
                } else {
                }
            });

            // Remove Symbols of function names
            _.forEach(_.values(dctFunction), (fncName) => {
                if(fncName in dctSymbols)
                    delete dctSymbols[fncName]
            })
            rv.symbols = _.keys(dctSymbols)
            rv.functions = _.keys(dctFunction)
            rv.expressionFnc = rv.expressionNode.compile()
            this.dct[expression] = rv
        } catch(err) {
            rv.error = true
            rv.errorMessage = `Failed to parse, ${err.toString()}`
            this.dct[expression] = rv
        }

        return rv
    }

}